import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPuzzle20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconPuzzle20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.58 5.9H4a.5.5 0 0 0-.5.5V16a.5.5 0 0 0 .5.5h1.94v-.54a2.86 2.86 0 0 1 5.72 0v.54h1.94a.5.5 0 0 0 .5-.5v-3.58h2.18a1.22 1.22 0 1 0 0-2.44H14.1V6.4a.5.5 0 0 0-.5-.5h-3.58V3.72a1.22 1.22 0 0 0-2.44 0zm8.02 9.52v-1.5h.68a2.72 2.72 0 1 0 0-5.44h-.68V6.4a2 2 0 0 0-2-2h-2.08v-.68a2.72 2.72 0 0 0-5.44 0v.68H4a2 2 0 0 0-2 2V16a2 2 0 0 0 2 2h3.44v-2.04a1.36 1.36 0 0 1 2.72 0V18h3.44a2 2 0 0 0 2-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPuzzle20);
